// extracted by mini-css-extract-plugin
module.exports = {"container":"FigureWaiting_container__tD8nt","bg":"FigureWaiting_bg__RHpNg","rotate":"FigureWaiting_rotate__H_u8o","fg":"FigureWaiting_fg__xjpOu","fade":"FigureWaiting_fade__pMs3h"};